import { View } from "@react-pdf/renderer";
import { useContext } from "react";
import { BreakLine } from "./Components";
import { horizontalPadding, perelynRed, verticalPadding } from "./const";
import { LanguageContext } from "./CVPDF";
import { SmallTextPDF, TinyTextPDF } from "./Texts";
import { cvTranslations } from "./translations";

export default function Footer() {
  const language = useContext(LanguageContext);
  const t = cvTranslations[language];
  
  return (
    <View
      fixed
      style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        height: "91px",
      }}
    >
      <SmallTextPDF
        style={{
          padding: `${verticalPadding} ${horizontalPadding}`,
          color: perelynRed,
        }}
        render={({
          pageNumber,
          totalPages,
        }: {
          pageNumber: number;
          totalPages: number;
        }) => (totalPages - pageNumber === 0 ? "" : t.continuesOnNextPage)}
      />
      <BreakLine />
      <View
        style={{
          padding: `${verticalPadding} ${horizontalPadding}`,
          display: "flex",
          flexDirection: "row",
        }}
      >
        <TinyTextPDF>{t.page} </TinyTextPDF>
        <TinyTextPDF
          render={({ pageNumber }: { pageNumber: number }) => `${pageNumber}`}
        />
      </View>
    </View>
  );
}
